<template>
  <g>
    <path
      d="M23.223 14.3186H18.576C18.6983 13.9839 18.7762 13.6169 18.7762 13.239C18.7762 11.4467 17.2865 10 15.441 10C14.2738 10 13.2621 10.583 12.6618 11.4575L12.1059 12.1809L11.5501 11.4467C10.9498 10.583 9.9381 10 8.77081 10C6.92538 10 5.4357 11.4467 5.4357 13.239C5.4357 13.6169 5.51352 13.9839 5.63581 14.3186H1V30.5135H23.223V14.3186ZM15.441 12.1593C16.0525 12.1593 16.5527 12.6452 16.5527 13.239C16.5527 13.8328 16.0525 14.3186 15.441 14.3186C14.8296 14.3186 14.3293 13.8328 14.3293 13.239C14.3293 12.6452 14.8296 12.1593 15.441 12.1593ZM8.77081 12.1593C9.38225 12.1593 9.88252 12.6452 9.88252 13.239C9.88252 13.8328 9.38225 14.3186 8.77081 14.3186C8.15938 14.3186 7.65911 13.8328 7.65911 13.239C7.65911 12.6452 8.15938 12.1593 8.77081 12.1593ZM20.9996 28.3542H3.21229V26.1949H20.9996V28.3542ZM20.9996 22.9559H3.21229V16.478H8.85975L6.54741 19.5334L8.34837 20.7966L12.1059 15.8302L15.8635 20.7966L17.6644 19.5334L15.3521 16.478H20.9996V22.9559Z"
      :fill="iconColor"
    />
    <path
      d="M30.3495 20.6822H39.6094V23.2464H30.3495V27.0927L25.079 21.9643L30.3495 16.8359V20.6822Z"
      :fill="iconColor"
    />
  </g>
</template>

<script>
export default {
  props: {
    iconColor: {
      type: String,
      default: "#ee1c25"
    }
  }
};
</script>
